// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../rafap.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  height: 100%;
  margin: 0;
  font-family: "Trasandina Web", Trasandina, sans-serif;
  background-color: #f4f4f9;
  color: #333;
}

.background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.demo {
  background: rgba(255, 255, 255, 0.9);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

header {
  text-align: center;
  margin-bottom: 30px;
  color: #1B285E;
  font-family: "Trasandina Web", Trasandina, sans-serif;
}

header .fas {
  font-size: 24px;
  margin-right: 10px;
}

.MuiTextField-root {
  position: relative;
  margin-bottom: 20px;
}

.MuiTextField-root .fas {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
}

.MuiTextField-root input {
  padding-left: 40px;
  font-family: "Trasandina Web", Trasandina, sans-serif;
}

.MuiButton-root {
  border-radius: 25px;
  background-color: #1B285E;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  transition: background-color 0.3s;
  font-family: "Trasandina Web", Trasandina, sans-serif;
}

.MuiButton-root:hover {
  background-color: #121b42;
}

.MuiLink-root {
  cursor: pointer;
  color: #1B285E;
  transition: color 0.3s;
  font-family: "Trasandina Web", Trasandina, sans-serif;
}

.MuiLink-root:hover {
  text-decoration: underline;
  color: #121b42;
}

/* Asegurarse de que todos los elementos de texto usen Trasandina */
h1, h2, h3, h4, h5, h6, p, span, div, button, input, select, textarea {
  font-family: "Trasandina Web", Trasandina, sans-serif;
}

/* Estilos específicos para elementos de formulario */
input, select, textarea {
  font-family: "Trasandina Web", Trasandina, sans-serif !important;
}

/* Estilos para elementos de Material-UI */
.MuiTypography-root,
.MuiInputBase-root,
.MuiMenuItem-root,
.MuiListItemText-root,
.MuiTableCell-root,
.MuiChip-root,
.MuiAlert-root,
.MuiTooltip-tooltip,
.MuiDialogTitle-root,
.MuiDialogContentText-root {
  font-family: "Trasandina Web", Trasandina, sans-serif !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,qDAAqD;EACrD,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yDAAqC;EACrC,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,qDAAqD;AACvD;;AAEA,qDAAqD;AACrD;EACE,gEAAgE;AAClE;;AAEA,0CAA0C;AAC1C;;;;;;;;;;EAUE,gEAAgE;AAClE","sourcesContent":["body, html {\n  height: 100%;\n  margin: 0;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n  background-color: #f4f4f9;\n  color: #333;\n}\n\n.background {\n  background-image: url('../rafap.png');\n  height: 100vh;\n  width: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.demo {\n  background: rgba(255, 255, 255, 0.9);\n  padding: 40px;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 100%;\n}\n\nheader {\n  text-align: center;\n  margin-bottom: 30px;\n  color: #1B285E;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n}\n\nheader .fas {\n  font-size: 24px;\n  margin-right: 10px;\n}\n\n.MuiTextField-root {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.MuiTextField-root .fas {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #888;\n}\n\n.MuiTextField-root input {\n  padding-left: 40px;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n}\n\n.MuiButton-root {\n  border-radius: 25px;\n  background-color: #1B285E;\n  color: white;\n  padding: 10px 20px;\n  font-size: 16px;\n  transition: background-color 0.3s;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n}\n\n.MuiButton-root:hover {\n  background-color: #121b42;\n}\n\n.MuiLink-root {\n  cursor: pointer;\n  color: #1B285E;\n  transition: color 0.3s;\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n}\n\n.MuiLink-root:hover {\n  text-decoration: underline;\n  color: #121b42;\n}\n\n/* Asegurarse de que todos los elementos de texto usen Trasandina */\nh1, h2, h3, h4, h5, h6, p, span, div, button, input, select, textarea {\n  font-family: \"Trasandina Web\", Trasandina, sans-serif;\n}\n\n/* Estilos específicos para elementos de formulario */\ninput, select, textarea {\n  font-family: \"Trasandina Web\", Trasandina, sans-serif !important;\n}\n\n/* Estilos para elementos de Material-UI */\n.MuiTypography-root,\n.MuiInputBase-root,\n.MuiMenuItem-root,\n.MuiListItemText-root,\n.MuiTableCell-root,\n.MuiChip-root,\n.MuiAlert-root,\n.MuiTooltip-tooltip,\n.MuiDialogTitle-root,\n.MuiDialogContentText-root {\n  font-family: \"Trasandina Web\", Trasandina, sans-serif !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
